/**
 * Hub cards on dailysportslife.com home. Add blog or other apps here.
 * External links open in a new tab when external: true.
 */
export const portalLinks = [
  {
    id: 'soccer',
    title: 'Soccer',
    description:
      'Join clubs, vote on practice availability, and split balanced teams for pickup games.',
    href: '/soccer',
    internal: true,
    icon: '⚽',
    available: true,
  },
  {
    id: 'running',
    title: 'Running',
    description:
      'Join running clubs, pick published routes, vote on group runs, and share practice photos.',
    href: '/running',
    internal: true,
    icon: '🏃',
    available: true,
  },
  {
    id: 'hiking',
    title: 'Hiking',
    description:
      'Join hiking clubs, browse published trails, vote on group outings, and share photos from the trail.',
    href: '/hiking',
    internal: true,
    icon: '🥾',
    available: true,
  },
  {
    id: 'training',
    title: 'Training',
    description:
      'Separate plans for soccer and running—browse trainings, then log progress where tracking is ready.',
    href: '/training',
    internal: true,
    icon: '💪',
    available: true,
  },
  {
    id: 'blog',
    title: 'Blog',
    description: 'Stories, tips, and updates from Daily Sports Life.',
    href: '/blog',
    internal: true,
    icon: '📝',
    available: true,
  },
];
